import { render, staticRenderFns } from "./ElderlyRel.vue?vue&type=template&id=9ca76a3c&"
import script from "./ElderlyRel.vue?vue&type=script&lang=js&"
export * from "./ElderlyRel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports